import React, { useState, useRef } from'react';
import '../styles/Badge.css';
import { StatusDot } from '../assets/icons';
import { Tooltip } from './';

function Badge(props) {
    const bgColour = props.bgColour;
    const statusDot = props.statusDot;
    const statusDotColour = props.statusDotColour;
    const text = props.text;
    const textClass = props.textClass;
    const icon = props.icon;
    const tooltip = props.tooltip;
    const tooltipBody = props.tooltipBody;
    const tooltipPosition = props.tooltipPosition;
    const iconLeft = props.iconLeft;
    const [showTooltip, setShowTooltip] = useState(false);

    // Store a reference to the timer so we can clear it
    const hoverTimer = useRef(null);

    // Start the 2-second timer on mouse enter
    const handleMouseEnter = () => {
        hoverTimer.current = setTimeout(() => {
            setShowTooltip(true);
        }, 500);
    };

    // Clear the timer and hide the tooltip on mouse leave
    const handleMouseLeave = () => {
        clearTimeout(hoverTimer.current);
        setShowTooltip(false);
    };

    return (
        <div 
            className={"badge-container relative-container " + (bgColour)}
            onMouseEnter={() => tooltip === true && handleMouseEnter()}
            onMouseLeave={() => tooltip === true && handleMouseLeave()}
        >
            {
                statusDot === true &&
                <StatusDot
                    className="badge-status-dot"
                    fill={statusDotColour}
                />
            }
            {
                icon !== null && iconLeft === true &&
                icon
            }
            <span className={textClass}>
                {text}
            </span>
            {
                icon !== null && iconLeft === false &&
                icon
            }
            {
                tooltip === true &&
                <Tooltip
                    type="info"
                    title={text}
                    body={tooltipBody}
                    position={tooltipPosition}
                    contextTooltipBg={null}
                    exit={false}
                    exitFunc={null}
                    customClass={showTooltip ? "fade-in" : "fade-out"}
                />
            }
        </div>
    )
};

export default Badge;